import { isNil, omitBy } from "lodash";

export function omitByNil(obj) {
  return omitBy(obj, isNil);
}
